let classCounter = 0;

// Generate a unique class name to avoid conflicts.
// Without this in prod: Check\$1-root-1-1-80 & Check\1-root-1-1-80 conflict
export const generateClassName = rule => {
  classCounter += 1;
  return `${rule.key}-${classCounter}`;
};
